import { buildRpaDomainSeoBundle } from "../rpaSeoUtils";

export const MEDIA_DOMAIN_INTRO = {
  title: "Media & Entertainment",
  content: "Document AI + RPA and workflow automation across Advertising, Production Houses. Each use case includes challenge and solution detail, process diagrams, and human-in-the-loop review for enterprises in India, UAE, KSA, UK, and USA.",
  seoDescription: "Media & Entertainment automation use cases — document AI + RPA and workflow automation across Advertising, Production Houses. Validation, approvals, system updates, and exception handling.",
};

const slugify = (label) =>
  label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) {
  return {
    ...uc,
    groupId: slugify(uc.subIndustry),
    seoTitle: uc.title,
    title: uc.shortTitle || uc.title,
    systems: uc.systems || SYSTEMS,
  };
}

const SYSTEMS = "MAM, CMS, CRM, Social Platforms, Email, Power BI";

const RAW = [
  {
    id: "ad-campaign-trafficking-qa",
    subIndustry: "Advertising",
    department: "Ad Operations",
    businessProcess: "Ad campaign trafficking QA",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Ad campaign trafficking QA",
    title: "Ad Campaign Trafficking Qa Automation for Media & Entertainment",
    seoKeywords: "media & entertainment, ad campaign trafficking qa, AI automation, RPA, agentic AI",
    challenge: "Ad tags, creatives, targeting and launch checklists are reviewed manually.",
    solution: "Implement RPA + Workflow Automation to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    automationType: "RPA + Workflow Automation",
    buyerPersona: "Ad Operations Head",
    systems: "Ad Server, Campaign Manager, CRM, Email",
    agentsRequired: "RPA Posting Agent, Ad Validation Agent, Exception Agent",
    inputData: "Emails, forms, system records, task notes, master data and ad campaign trafficking qa process rules",
    outputActions: "Validated workflow record, task assignment, status update and exception report for ad campaign trafficking qa",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "3-6 months",
    implementationComplexity: "Medium",
    businessImpact: "High",
  },
  {
    id: "production-expense-processing",
    subIndustry: "Production Houses",
    department: "Finance",
    businessProcess: "Production expense processing",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Production expense processing",
    title: "Production Expense Processing Automation for Media & Entertainment",
    seoKeywords: "media & entertainment, production expense processing, AI automation, RPA, agentic AI, document AI",
    challenge: "Production bills, petty cash, vendor invoices and approvals are processed manually.",
    solution: "Implement Document AI + RPA to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    automationType: "Document AI + RPA",
    buyerPersona: "Production Finance Head",
    systems: "ERP, Expense System, Email, DMS",
    agentsRequired: "Document Extraction Agent, Production Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and production expense processing rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready production expense processing record",
    keyBenefits: "Faster Closure, Fewer Reconciliation Errors, Reduced Manual Effort And Better Finance Visibility",
    roiTimeline: "3-6 months",
    implementationComplexity: "Medium",
    businessImpact: "High",
  },
];
export const MEDIA_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["Advertising", "Production Houses"];
export const MEDIA_GROUPS = GROUP_ORDER.map((label) => ({
  id: slugify(label),
  label,
})).filter((g) => MEDIA_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildRpaDomainSeoBundle({
  domainSlug: 'media-entertainment-domain',
  domainIntro: MEDIA_DOMAIN_INTRO,
  useCases: MEDIA_USE_CASES,
});
export const MEDIA_USE_CASES_SEO = seo.useCasesSeo;
export const MEDIA_DOMAIN_FAQS = seo.domainFaqs;
export const MEDIA_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const MEDIA_FAQ_JSONLD = seo.faqJsonLd;
export const MEDIA_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const MEDIA_WEBPAGE_JSONLD = seo.webPageJsonLd;

